// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"334":"3be6a65d","631":"66bc856b"}[chunkId] + ".chunk.css";
};